import { createContext, useContext, useEffect, useState } from "react";

const RoleContext = createContext(null);

export function RoleProvider({ children }) {
  // Learner data is now read from localStorage (set at login)
  const [learner, setLearnerState] = useState(() => {
    const learnerId = sessionStorage.getItem("learner_id");
    const learnerName = sessionStorage.getItem("learner_name");
    const learnerGrade = sessionStorage.getItem("learner_grade");
    
    if (learnerId) {
      return {
        learner_id: learnerId,
        name: learnerName || "Student",
        grade: parseInt(learnerGrade || "5", 10),
      };
    }
    return null;
  });

  // Teacher ID is now read from localStorage (set at login)
  const [teacherId, setTeacherIdState] = useState(() => {
    return sessionStorage.getItem("teacher_id") || "teacher-default";
  });

  const setTeacherId = (id) => {
    setTeacherIdState(id);
    sessionStorage.setItem("teacher_id", id);
  };

  // Update learner state when localStorage changes (e.g., after login)
  useEffect(() => {
    const handleStorageChange = () => {
      const learnerId = sessionStorage.getItem("learner_id");
      const learnerName = sessionStorage.getItem("learner_name");
      const learnerGrade = sessionStorage.getItem("learner_grade");
      
      if (learnerId) {
        setLearnerState({
          learner_id: learnerId,
          name: learnerName || "Student",
          grade: parseInt(learnerGrade || "5", 10),
        });
      } else {
        setLearnerState(null);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const setLearner = (next) => {
    setLearnerState(next);
    if (next?.learner_id) {
      sessionStorage.setItem("learner_id", next.learner_id);
      sessionStorage.setItem("learner_name", next.name || "");
      sessionStorage.setItem("learner_grade", String(next.grade || 5));
    }
  };

  return (
    <RoleContext.Provider value={{ learner, setLearner, teacherId, setTeacherId }}>
      {children}
    </RoleContext.Provider>
  );
}

export const useRole = () => useContext(RoleContext);
